module.exports = __webpack_public_path__ + "static/lato-latin-700.b68c39cb.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-700.woff2
// module id = ./node_modules/typeface-lato/files/lato-latin-700.woff2
// module chunks = 17241999800008180000